var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 23
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35058"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 687",
    fill: "#fff",
    stroke: "#11385a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 23,
    rx: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 22,
    rx: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34847"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Search Icon",
    fill: "none",
    stroke: "#11385a"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 293",
    transform: "translate(11.959 4.961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.873,
    cy: 5.873,
    r: 5.873,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.873,
    cy: 5.873,
    r: 5.373
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 64",
    strokeLinecap: "round",
    d: "M22.285 15.287l2.754 2.754"
  }))))));
}

export default SvgMobileSearch;